import { render, staticRenderFns } from "./sort-2.vue?vue&type=template&id=1eddef3f&scoped=true"
import script from "./sort-2.vue?vue&type=script&lang=js"
export * from "./sort-2.vue?vue&type=script&lang=js"
import style0 from "./sort-2.vue?vue&type=style&index=0&id=1eddef3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eddef3f",
  null
  
)

export default component.exports